export default __webpack_public_path__ + "static/media/exit-down.30d88ac7.svg";